import { createClient } from "@supabase/supabase-js";

const url = import.meta.env.VITE_SUPABASE_URL;
const cle = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!url || !cle) {
  // Mieux vaut un message clair au démarrage qu'une erreur réseau opaque.
  console.warn(
    "Omnix Desk : VITE_SUPABASE_URL ou VITE_SUPABASE_ANON_KEY manquante. " +
      "Copiez .env.example vers .env et renseignez le projet Supabase.",
  );
}

/* ─────────────────────────── le lien d'arrivée ──────────────────────────────
   Les courriels d'invitation et de réinitialisation passent par le point de
   vérification du serveur, qui renvoie ici avec les jetons dans le fragment de
   l'adresse — jamais dans la requête. C'est la forme « implicite ».

   On ne laisse pas la bibliothèque ramasser ce fragment toute seule : elle
   attend par défaut l'autre forme (PKCE, avec un code dans la requête) et
   repousse silencieusement celle-ci. Le jeton restait alors dans la barre du
   navigateur, sans session ouverte, et l'écran de connexion s'affichait comme
   si le lien n'avait servi à rien.

   On lit donc le fragment une fois, ici, avant toute chose, et c'est la
   session qui pose les jetons elle-même. */

const fragment = new URLSearchParams(window.location.hash.replace(/^#/, ""));

/** `invite` quand la direction ouvre un compte, `recovery` après un oubli. */
export const typeDeLien: string | null = fragment.get("type");

/** Les jetons portés par le lien, s'il en portait. */
export const jetonsDeLien: { acces: string; rafraichissement: string } | null =
  fragment.get("access_token") && fragment.get("refresh_token")
    ? {
        acces: fragment.get("access_token") as string,
        rafraichissement: fragment.get("refresh_token") as string,
      }
    : null;

/**
 * Ce que le lien reproche, s'il a été refusé. Un lien d'invitation ne sert
 * qu'une fois : cliqué deux fois, le second clic arrive ici.
 */
export const erreurDeLien: string | null = fragment.get("error_code")
  ? fragment.get("error_code") === "otp_expired"
    ? "Ce lien a déjà servi, ou il a expiré. Demandez-en un nouveau ci-dessous."
    : "Ce lien n'est plus valable. Demandez-en un nouveau ci-dessous."
  : null;

/** Efface le fragment : un jeton n'a rien à faire dans la barre d'adresse. */
export function nettoyerAdresse(): void {
  if (!window.location.hash) return;
  window.history.replaceState(null, "", window.location.pathname + window.location.search);
}

export const supabase = createClient(url ?? "", cle ?? "", {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: false,
    flowType: "implicit",
  },
});
